// Shared helpers for working with Call records on either end.

import type { Call } from './types.js';

export function getCounterpartyNumber(
  call: Pick<Call, 'direction' | 'fromNumber' | 'toNumber'>,
): string {
  return call.direction === 'outbound' ? call.toNumber : call.fromNumber;
}
